import React from 'react';
import Parameters from './components/Parameters';
import Loading from './components/Loading';
import SupplierInfos from './components/price/SupplierInfos';
import PriceMatrices from './components/price/PriceMatrices';

const Fabrication = () => (
  <>
    <Loading />
    <div className="row">
      <div className="col-lg-4">
        <div className="parameters">
          <Parameters />
        </div>
      </div>
      <div className="col-lg-8">
        <h2 className="offshore-pcb-title">
          Get an instant quote from our network of PCB partners in China.
        </h2>
        <div className="pcb-price-section">
          <SupplierInfos />
          <PriceMatrices />
        </div>
      </div>
    </div>
  </>
)

export default Fabrication;
